var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coffee",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.329,
    height: 10.648,
    viewBox: "0 0 12.329 10.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M40.56,20a.56.56,0,0,0-.56.56v1.121a.56.56,0,0,0,1.121,0V20.56A.56.56,0,0,0,40.56,20Z",
    transform: "translate(-37.758 -20)",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M14.725,67.846a3.363,3.363,0,0,0,3.316-2.8h.047a2.242,2.242,0,1,0,0-4.483V60H8v4.483a3.362,3.362,0,0,0,3.362,3.362Zm-5.6-6.725v3.362a2.242,2.242,0,0,0,2.242,2.242h3.362a2.242,2.242,0,0,0,2.242-2.242V61.121ZM19.208,62.8a1.121,1.121,0,0,1-1.121,1.121V61.681A1.121,1.121,0,0,1,19.208,62.8Z",
    transform: "translate(-8 -57.198)",
    fill: "#FFA500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M72,20.56a.56.56,0,0,1,1.121,0v1.121a.56.56,0,0,1-1.121,0Z",
    transform: "translate(-67.517 -20)",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M104.56,20a.56.56,0,0,0-.56.56v1.121a.56.56,0,1,0,1.121,0V20.56A.56.56,0,0,0,104.56,20Z",
    transform: "translate(-97.275 -20)",
    fill: "#FFA500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarm);
export default __webpack_public_path__ + "static/media/warm.d6d590d03e3f38ebe4308f3c4ca71235.svg";
export { ForwardRef as ReactComponent };